<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <b-card class="p-0" no-body>
      <section class="chat-app-window w-100">
        <!-- Chat Content -->
        <div class="active-chat">
          <ChatHeader v-if="userInfo" :userInfo="userInfo" @readMessages="seenMessages"></ChatHeader>
          <vue-perfect-scrollbar
              id="chat-container"
              ref="refChatLogPS"
              :settings="perfectScrollbarSettings"
              class="user-chats scroll-area position-relative"
              style="min-height: 65dvh; max-height:65dvh;overflow-x: hidden;overflow-y: auto"
          >
            <template v-if="conversation && conversation.length > 0">
              <chat-log
                  v-for="(message,idx) in conversation"
                  :key="idx"
                  :chat-data="message"
                  :profile-user-avatar="userInfo.selfieFileData"
                  @deleteItem="deleteMessage"
              />
            </template>
          </vue-perfect-scrollbar>
          <ChatEntries
              ref="chatEntries"
              @sendNewMedia="getMedia"
              @sendNewMessage="getMessage"
              @showEmojis="showEmojis = !showEmojis"
          ></ChatEntries>
        </div>
        <!-- Chat Content -->
      </section>
    </b-card>
  </b-overlay>
</template>

<script>
import {hubInstance} from '@/libs/chatHub';
import {BCard, BOverlay,} from 'bootstrap-vue'
import vSelect from 'vue-select'
import EmojiPicker from '@/views/components/chat/EmojiPicker.vue'
import ChatHeader from '@/views/components/newChat/ChatHeader.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ChatEntries from '@/views/components/newChat/ChatEntries.vue'
import ChatLog from "@/views/apps/chat/ChatLog.vue";

export default {
  name: 'newChat',
  title: 'چت - پنل ادمین نهایی شو',
  data() {
    return {
      onlineChatId: Number(this.$route.params.id),
      message: '',
      userInfo: null,
      mediaObj: null,
      showOverlay: false,
      showEmojis: false,
      content: '',
      totalCount: null,
      hub: null,
      conversation: [],
      currentPage: 1,
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      }
    }
  },
  inject: ['chatHub'],
  async mounted() {
    if (!hubInstance.isConnected()) {
      this.chatHub.onMyConnected.push(function () {
        this.getConversation(true);
      }.bind(this));
    } else {
      if (hubInstance.isConnected()) {
        await this.getConversation(true);
      }
    }
  },
  methods: {
    async getConversation(scrollBottom) {
      this.showOverlay = true;

      // Deliver
      this.chatHub.on("DeliverySuccess", function (res) {
        this.conversation.forEach(el => {
          if (el.isMe) el.isDeliver = true;
        })
      }.bind(this));
      this.chatHub.invoke("Delivery", this.onlineChatId);

      // Get messages
      await new Promise((resolve, reject) => {
        this.chatHub.on("GetMyMessageSuccess", function (res) {
          this.conversation = [];
          this.userInfo = res.userInfo.userInfo;
          res.data.forEach(el => {
            this.conversation.push(el);
          })
          if (scrollBottom) {
            this.scrollToBottom()
          }
        }.bind(this));
        resolve('resolved');
      })
      this.chatHub.invoke("GetMyMessage", this.onlineChatId, 1, 100);

      // Seen
      this.chatHub.on("SeenSuccess", function (res) {
        this.conversation.forEach(el => {
          if (el.isMe) el.isSeen = true;
        })
      }.bind(this));
      // this.chatHub.invoke("Seen", this.onlineChatId);

      // New message
      this.chatHub.on("NewMessageSuccess", function (res) {
        this.conversation.push(res);
        if (!res.isMe) {
          this.chatHub.invoke("Delivery", this.onlineChatId);
          this.chatHub.invoke("Seen", this.onlineChatId);
        }
        this.scrollToBottom();
      }.bind(this));
      this.showOverlay = false;
    },
    checkScroll(event) {
      if (event.target.scrollTop === 0) {
        this.currentPage++
        if (this.currentPage <= this.totalCount) {
          this.getConversation(false)
        }
      }
    },
    getMedia(media) {
      this.message = media.file;
      this.mediaObj = null;
      this.sendMessage(media.type);
    },
    getMessage(message) {
      this.message = message;
      this.mediaObj = null;
      this.sendMessage(1);
    },
    sendMessage(type) {
      this.chatHub.invoke('NewMessage', this.onlineChatId, this.message, type)
      this.$refs.chatEntries.clearMessage();
    },
    seenMessages() {
      this.chatHub.invoke("Seen", this.onlineChatId);
    },
    deleteMessage(message) {

    },
    addEmoji(param) {
      this.content += param.emoji
    },
    scrollToBottom() {
      if (this.conversation && this.conversation.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.refChatLogPS) {
            this.$refs.refChatLogPS.$el.scrollTop = this.$refs.refChatLogPS.$el.scrollHeight
          }
        })
      }
    },
  },
  async beforeDestroy() {
    if (this.chatHub) {
      await this.chatHub.off("NewMessageSuccess");
      await this.chatHub.off("SeenSuccess");
      await this.chatHub.off("DeliverySuccess");
    }
  },
  components: {
    ChatLog,
    ChatEntries,
    ChatHeader,
    VuePerfectScrollbar,
    EmojiPicker,
    BCard,
    BOverlay,
    vSelect,
  },
}
</script>

<style>

/* width */
::-webkit-scrollbar {
  width: 0px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #2a2a2a;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.chat-bg {
  background-color: #f2f0f7;
  background-size: 235px;
}
</style>


<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>

